import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-cancel-invitation.hbs';

    var CancelInvitationDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        id: 'cancel-invitation-dialog',
        ui: {
            removeButton: 'button[type="submit"]'
        },
        events: {
            'click @ui.removeButton': 'onClickRemove',
        },
        initialize: function(options) {
            this.destroyOnClose();
        },
        onClickRemove: function(e) {
            e.preventDefault();
            // Disable submit button to avoid sending multiple requests
            this.ui.removeButton.prop('disabled', true);

            this.model.destroy({
                complete: _.bind(function() {
                    this.closeDialog();
                }, this),
                error: function() {
                    Radio.request('alerts', 'showAlert', {
                        message: 'Failed to delete invitation',
                        messageType: 'danger'
                    });
                }
            });
        }
    });
    export default CancelInvitationDialog;

